import React from "react";
import StayCard from "./StayCard";

export default function DaySection({ day, stays, eventsByStay }) {
  const formattedDay = new Intl.DateTimeFormat("fr-FR", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
    .format(new Date(day))
    .replace(/\./g, "");

  return (
    <div className="mb-4">
      <div className="text-center font-bold capitalize text-black mb-2">
        {formattedDay}
      </div>
      <div className="space-y-2">
        {stays.map((stay) => (
          <StayCard
            key={stay.sId}
            stay={stay}
            events={(eventsByStay[stay.sId] || []).sort((a, b) => {
              const aTime = new Date(a.eventAt || a.srwCreatedAt || stay.checkIn).getTime();
              const bTime = new Date(b.eventAt || b.srwCreatedAt || stay.checkIn).getTime();
              return bTime - aTime;
            })}
          />
        ))}
      </div>
    </div>
  );
}
